import { getEnvVariable } from '@/utils';

export const IS_BUILD_FOR_OFFLINE = getEnvVariable('REACT_APP_IS_BUILD_FOR_OFFLINE', 'false') === 'true';